import { translateUi } from "../lib/i18n.ts";
import { Component, type ReactNode } from "react";

export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="callback-screen">
      <section className="callback-state" role="alert">
        <h1>{translateUi("Faqja nuk u ngarkua", "Page could not be loaded")}</h1>
        <p>{translateUi("Ndodhi një gabim gjatë hapjes së faqes. Prit pak dhe provo përsëri.", "An error occurred while opening the page. Wait a moment and try again.")}</p>
        <button type="button" className="primary-action compact" onClick={() => window.location.reload()}>{translateUi("Provo përsëri", "Retry")}</button>
      </section>
    </main>;
  }
}
